module.exports = __webpack_public_path__ + "img/report_page_visualization.f9f36cd0.svg";